import { useEffect, useState } from "react";
import { Typography, Row, Col, Input, Select, Alert } from "antd";
import { useNavigate } from "react-router-dom";
import { useSelector } from "react-redux";

const EditDepartment = ({ id }) => {
  const { MainResponse } = useSelector((state) => state);

  const [oldDepartmentName, setOldDepartmentName] = useState("");
  const [departmentName, setDepartmentName] = useState("");
  const [companyName, setCompanyName] = useState("");
  const [showAlert, setShowAlert] = useState(false);
  const [buttonDisable, setButtonDisable] = useState(false);

  const navigate = useNavigate();

  const handleChange = (value) => {
    setCompanyName(value);
  };

  useEffect(() => {
    getADepartment();
  }, []);

  const getADepartment = async () => {
    let result = await fetch(
      `${process.env.REACT_APP_BACKEND_URL}/get-department/${id}`,
      {
        headers: {
          authorization: `bearer ${JSON.parse(localStorage.getItem("token"))} `,
        },
      }
    );
    result = await result.json();
    if (result) {
      setOldDepartmentName(result.departmentName);
      setDepartmentName(result.departmentName);
      setCompanyName(result.companyName);
    }
  };

  const updateDepartment = async () => {
    if (departmentName && companyName) {
      setButtonDisable(true);

      let result = await fetch(
        `${process.env.REACT_APP_BACKEND_URL}/department-update/${id}`,
        {
          method: "put",
          body: JSON.stringify({
            oldDepartmentName,
            departmentName,
            companyName,
          }),
          headers: {
            "Content-Type": "application/json",
            authorization: `bearer ${JSON.parse(
              localStorage.getItem("token")
            )} `,
          },
        }
      );
      result = await result.json();

      if (result) {
        setButtonDisable(false);
        navigate(-1);
      }
    } else {
      setShowAlert(true);
    }
  };

  return (
    <>
      {showAlert && (
        <Alert
          onClose={() => setShowAlert(false)}
          message="Diqqət!"
          description="Zəhmət olmasa boş sahələri doldurun!"
          type="warning"
          showIcon
          closable
        />
      )}
      <Row className="add-row">
        <Col span={8}>
          <Typography.Text className="add-title">Şöbənin adı</Typography.Text>
          <Input
            className="add-input"
            size="large"
            value={departmentName}
            onChange={(e) => setDepartmentName(e.target.value)}
          />
        </Col>
        <Col span={8}>
          <Typography.Text className="add-title">Şirkət</Typography.Text>

          <Select
            size="large"
            value={companyName}
            onChange={handleChange}
            className="add-dropdown"
            options={MainResponse.allCompanyNames}
          />
        </Col>
        <Col span={4}>
          <button
            disabled={buttonDisable}
            className="success-button"
            onClick={updateDepartment}
          >
            Təsdiq Et
          </button>
        </Col>
        <Col span={4}>
          <button
            className="cancel-button"
            onClick={() => {
              navigate(-1);
            }}
          >
            İmtina Et
          </button>
        </Col>
      </Row>
    </>
  );
};

export default EditDepartment;
